export default "__VITE_ASSET__Dk48D9dr__"